export class Base64DecoderService {
  decode(data: string): string {
    return atob(data);
  }
}
